
const montaRetornoUnitizadorPadraoPagination = (unitizador:any, setValoresPaginacao:any) => {
    const length = unitizador && Array.isArray(unitizador) ? unitizador.length : 0;
    const data = unitizador && Array.isArray(unitizador) && unitizador.length > 0 && unitizador[0].dataExpedicao ? unitizador[0].dataExpedicao : '01/01/1900 00:00:00';

    const pg= {
        pageNumber: 0,
        pageSize: length,
        pageTotalElements: length,
        totalElements: length,
        totalPages: length > 0 ? 1 : 0,
        dataInicioPeriodo: data,
        dataFinalPeriodo: data
    }

    setValoresPaginacao(()=>pg);

};

export { montaRetornoUnitizadorPadraoPagination };